import { graphql } from '../../graphql/generated';

export const LABS_QUERY = graphql(`
  query Labs {
    labs {
      id
      name
      shortName
      longName
    }
  }
`);
